import { Group, Vector3, Geometry, Line, MathUtils, LineBasicMaterial, Color, BufferGeometry, BufferAttribute } from 'three';
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min.js';

class Ems1 extends Group {
    constructor(parent) {
        // Call parent Group() constructor
        super();

        const material = new LineBasicMaterial( {
	          color: new Color("rgb(255, 0, 0)"),
	          linewidth: 8,
            opacity: 1.0,
            transparent: true,
	          linecap: 'round', //ignored by WebGLRenderer
	          linejoin:  'round' //ignored by WebGLRenderer
        } );

        // Init state
        this.state = {
            vs: [],
            ls: [],
            mat: material,
            set: this.set.bind(this),
            timeStamp: 0,
        };

       var geometry = new Geometry();

	      geometry.vertices.push(new Vector3(3, 0, 0));
        geometry.vertices.push(new Vector3(0, 0, 0));
        geometry.vertices.push(new Vector3(1.5, 2.6, 0));
        geometry.vertices.push(new Vector3(3, 0, 0));

        for (var i = 0; i<8; i++){
            var line = new Line(geometry);
            line.material = material;
            this.add(line);
            this.state.ls.push(line);
            this.state.vs.push(new Vector3(1,0,0));
        }
        this.visible = false;
        this.name = "effect";
        // Add self to parent's update list
        parent.addToUpdateList(this);
    }

    set(){
        const speed = 0.3;
        this.state.vs = [];
        for (var i = 0; i< 8; i++){
            this.state.ls[i].position.copy(new Vector3(0,0,0));
            this.state.vs.push(new Vector3(MathUtils.randFloat(-speed, speed), MathUtils.randFloat(-speed, speed),MathUtils.randFloat(-speed, speed)));
            //console.log(this.state.vs[i]);
        }
        this.state.mat.opacity = 1;
        this.visible = true;
    }

    update(timeStamp) {
        if(this.visible){
            for (var i = 0; i< 8; i++){
                this.state.ls[i].position.add(this.state.vs[i]);
                this.state.ls[i].rotation.y += this.state.vs[i].z;
                this.state.ls[i].rotation.x += this.state.vs[i].x;
                this.state.ls[i].rotation.z += this.state.vs[i].y;
            }

            this.state.mat.opacity -= .03;
            if (this.state.mat.opacity <= 0.0) this.visible = false;
        }
    }
}


export default Ems1;
